@if (pageReady) {
  <div class="header">
    <h2>{{ pageData.paymentAccountType }}</h2>
  </div>

  @if (openingInBrowser()) {
    <div class="opening-browser-message" data-cy="opening-browser-message">
      <p>{{ pageLabels?.openingBrowserMessage || "Opening payment in browser..." }}</p>
      <p class="opening-browser-hint">
        {{ pageLabels?.openingBrowserHint || "Complete the payment in the browser window, then return here." }}
      </p>
    </div>
  } @else if (showIframe) {
    <iframe
      id="paymentusIframe"
      [src]="pageData.url | safe: 'resourceUrl'"
      allow="payment"
      frameborder="0"
      data-cy="paymentus-iframe"
    ></iframe>
  } @else {
    <app-notification [pageName]="pageName"></app-notification>
  }

  <div class="buttons-wrapper">
    <button
      mat-flat-button
      class="gs-form-button-primary"
      color="primary"
      (click)="closeModal()"
      data-cy="btn-cancel-digital-payment"
    >
      {{ pageLabels.digitalPaymentCancelButtonText }}
    </button>
  </div>
}
